<template lang="pug">
template-editor(v-if="findComponentTemplate(component)" :component="component" @close-dialog="$emit('close-dialog')")

v-card(v-else)
  v-card-title
    .subtitle-1 Template Manager

  v-card-text
    v-layout
      v-flex(sm4)
        .overline.mb-1 Create a new Template
        v-btn(small @click="createComponentTemplate(component)") Create

      v-flex(sm4)
        .overline.mb-1 Load a PapArtisan Template
        p.caption.grey--text Coming soon...

      v-flex(sm4)
        .overline.mb-1 Copy another Template
        p.caption.grey--text Coming soon...
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  import TemplateEditor from './TemplateEditor.vue'

  export default {
    props: ["component"],

    components: { TemplateEditor },

    data() { return { } },

    computed: mapGetters(["findComponentTemplate"]),

    methods: mapActions(["createComponentTemplate"])
  }
</script>
